import { Route } from '../config/routes'

export enum Features {
  ADJUSTED_DOWN_PAYMENT_MESSAGING = 'rocketship.adjusted-down-payment-messaging',
  ALLOWED_DOCUMENTS_BY_COUNTRY = 'allowed-documents-by-country',
  AUTOPAY_TOGGLE_ENABLED = 'paylater.autopay-toggle-enabled',
  ATLAS_TRANSLATIONS_ENABLED = 'rocketship-checkout-atlas-integration',
  APPLE_PAYLATER_INTEGRATION = 'rocketship-apple-paylater-integration',
  PAYMENT_TYPE_SORTING = 'rocketship.payment-type-sorting',
  BYPASS_IDV_FOR_CONSUMER_LENDING_ORDERS = 'bypass-idv-for-consumer-lending-orders',
  BYPASS_IDV_FOR_SUP_CPI4 = 'bypass-idv-for-sup-cpi4',
  CASH_MAINTENANCE_MODE_TEXT = 'cash-maintenance-mode-text',
  CHECKOUT_BLOCK_CAP_ONE_MC_DEBIT_CARDS = 'checkout-block-cap-one-mc-debit-cards',
  CHECKOUT_GIFT_CARD_MERCHANTS_FLOW = 'rocketship.checkout-gift-card-flow-merchants',
  CHECKOUT_GIFT_CARD_PROMOTION_UI_ENABLED = 'rocketship.checkout-gift-card-promotion-ui-enabled',
  CHECKOUT_MANUAL_PROMO_CODE_ENTRY = 'checkout-manual-promo-code-entry',
  CHECKOUT_PAY_IN_2_AMOUNT = 'paylater.checkout-pay-in-2-order-amount',
  MONOCHROME_NEW_DESIGN_TOAST = 'rocketship.monochrome-new-design-toast',
  CHECKOUT_SAVE_NEW_CARD = 'checkout-save-new-card',
  CHECKOUT_THREE_DS_ENABLED = 'checkout-three-ds-enabled',
  CONSUMER_LENDING_AU_OPEN_BANKING_FLOW_DISABLED = 'consumer-lending-au-open-banking-flow-disabled',
  CONVERGENCE_LOGIN_EXTENDED = 'checkout-convergence-login-extended',
  CONVERGENCE_ROLLOUT = 'checkout-convergence-rollout',
  CONVERGENCE_ACTIVE_VARIANTS = 'checkout-convergence-active-variants',
  CONVERGENCE_CASH_PAY_MONTHLY_ENABLED = 'checkout-convergence-cash-pay-monthly-enabled',
  DONATION_ENABLED = 'donation-enabled',
  ENABLE_ALIGN_PAYMENT_DAY = 'rocketship.enable-align-payment-day',
  ENABLE_APPLE_PAY_FOR_NEW_CHECKOUT = 'enable-apple-pay-for-new-checkout',
  APPLE_PAY_DISABLE_CREDIT_CARD_IN_CHECKOUT = 'rocketship.apple-pay-disable-credit-card-in-checkout',
  ENABLE_CASH_LOGIN_DOMAIN_APIS = 'paylater.enable-cash-login-domain-apis',
  ENABLE_CHECKOUT_EVERGREEN_CONSENT = 'rocketship.enable-checkout-evergreen-consent',
  ENABLED_PERSONALIZATION = 'enable-checkout-personalization',
  IGNORE_ASSET_IMPRESSIONS = 'checkout-ignore-asset-impressions',
  INTERNATIONAL_SHIPPING_ENABLED = 'international-shipping-enabled',
  MAINTENANCE_MODE = 'maintenance-mode',
  MAINTENANCE_MODE_TEXT = 'maintenance-mode-text',
  OAUTH_FOR_UNICORN = 'oauth-for-unicorn',
  ONE_OFFER_PAGE = 'rocketship.enable-one-offer-page',
  ORDER_AMOUNT_EXCEEDS_SPEND_CAP = 'rocketship.order-amount-exceeds-spend-cap-error',
  OTP_AS_PRIMARY_LOGIN_METHOD = 'rocketship.otp-as-primary-login-method',
  PARTIAL_LATE_FEES = 'rocketship.partial-late-fees',
  PAY_MONTHLY_FOR_SUP_ENABLED = 'paylater.pay-monthly-for-single-use-payments-enabled',
  POST_CHECKOUT_CAPTURE_TYPE = 'rocketship.capture-type-in-post-checkout',
  ROSELLA_PAYMENT_IN_CHECKOUT = 'rosella-payment-in-checkout',
  VERIFY_SERVICE_TEST_TARGETING = 'rocketship.verify-service.test-targeting',
  VERIFY_SMS_DELAY = 'rocketship.verify-service.sms-delay',
  CHECKOUT_LONG_LIVE_SESSION_ENABLED = 'checkout-long-live-session-enabled',
  CHECKOUT_ENABLE_ADD_PAYMENT_METHOD_PM_PI4_SWITCHER_SUMMARY_FIRST = 'checkout-enable-add-payment-method-pm-pi4-switcher-summary-first',
  ENABLE_CARD_ADD_FOR_CASH_COHORT = 'enable-card-add-for-cash-cohort',
  ENABLE_APPLE_PAY_FOR_CASH_COHORT = 'enable-apple-pay-for-cash-cohort',
  HIDE_AUTOPAY_TOGGLE_FOR_CASH_COHORT = 'hide-autopay-toggle-for-cash-cohort',
  APPLE_RETAIL_ENABLED = 'apple-retail-enabled',
  CASH_AUTH_POLLING_LIMIT = 'rocketship.cash-auth-polling-limits',
  ENABLE_APPLE_PAYLATER_APPLE_PAY_REPAYMENT = 'rocketship.enable-apple-paylater-applepay-repayment',
  ENABLE_FETCH_APPLE_PAYLATER_APPLE_PAY_REPAYMENT = 'rocketship.enable-fetch-apple-paylater-applepay-repayment',
  DEFER_CHECKOUT_FOR_AMOUNT_ADJUSTMENT = 'rocketship.defer-checkout-for-amount-adjustment',
  ENABLE_APPLE_PAYLATER_REDIRECT_DEBUG = 'rocketship.enable-apple-paylater-redirect-debug',
  AU_PAY_IN_4_UPDATED_TERMS = 'rocketship.au-pay-in-4-updated-terms',
  AU_PAY_MONTHLY = 'rocketship.au-pay-monthly',
  CHECKOUT_ENABLE_DOWNLOAD_PPA_PDF_API = 'checkout-enable-download-pdf-api',
  USER_JOURNEY_INSTRUMENTATION = 'rocketship.user-journey-instrumentation',
  MOBILE_USER_JOURNEY_OWNERSHIP = 'rocketship.mobile-user-journey-ownership',
  CASH_USER_JOURNEY_FEDERATION_ENABLED = 'rocketship.cash-user-journey-federation-enabled',
}

export interface MerchantsWithAutoLanguage {
  values: number[]
}

export type OtpLoginRouteAndTriggerResult = (
  isTrustedSession: boolean,
  isBiometricsEligibleAndRegistered: boolean
) => Route.ONE_TIME_PASSWORD | Route.ENTER_PASSWORD
